import { render, staticRenderFns } from "./AnimatedHeart.vue?vue&type=template&id=3e80b7fc&scoped=true&"
import script from "./AnimatedHeart.vue?vue&type=script&lang=js&"
export * from "./AnimatedHeart.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedHeart.vue?vue&type=style&index=0&id=3e80b7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80b7fc",
  null
  
)

export default component.exports